(function($) {
  'use strict';

  if ($('html').hasClass('properties-listing')) {

    const communities = {
      dom: function() {
        this.$header = $('#header');
        this.$communitiesContent = $('#communitiesContent');
        this.$propertiesWrap = $('#propertiesWrap');
        this.$propertiesMain = $('#properties');
        this.$properties = $('#properties').children('[data-property]');
        this.$propertyCards = $('[data-property]');
        this.$cardLinks = $('.communities__item-link');
        this.$propertiesFilterInfo = $('#propertiesFilterInfo');
        this.$propertiesFilterInfoCount = $('#propertiesFilterInfoCount');
        this.$noresults = $('[data-js-hook="propertiesNoResults"]');
        this.$resultCount = $('.js-result-count-text');
        this.$mapContainer = $('#mapContainer');
        this.$mapToggle = $('[data-js-hook="map-toggle"]');
        this.$cardsCarousel = $('#communityCards');
        this.$carouselCards = this.$cardsCarousel.find('.communities__card');

        this.$filters = {
          form: $('#communityFilters'),
          filterCount: $('#filterCount'),
          all: $('#communityFilters').find(':input'),
          input: $('[data-filter="input"]'),
          select: $('[data-filter="select"]'),
          checkbox: $('[data-filter="checkbox"]'),
          reset: $('[data-filter="reset"]'),
          submit: $('[data-filter="submit"]'),
          dummy: $('[data-filter-dummy]')
        };
      },

      definitions: function() {
        this.matchedItems = [];
        this.notMatchedItems = [];
        this.carouselMatchedClasses = [];
        this.propertyIds = [];
        this.swiper = null;
      },

      mapHasLoaded: false,

      settings: {
        windowHeight: window.innerHeight
      },

      setHeights: function(event) {
        // return if window height hasn't changed
        if (event.type == 'resize' && window.innerHeight == communities.settings.windowHeight) {
          return;
        }

        communities.settings.windowHeight = window.innerHeight;
        var headerHeight = +$('.communities__header').outerHeight() + $('#header').outerHeight() + 40;

        var newHeight = communities.settings.windowHeight - headerHeight;

        communities.$propertiesWrap.height(newHeight);
      },

      validateProperty: function(search_data, property_data) {
        // loop through fields [AND]
        for (var key in search_data) {
          if (key) {
            // remove if no property data for that field
            if (property_data[key] == null) {
              return false;
            }

            var data = property_data[key].toLowerCase();

            if (typeof search_data[key] === 'string') {
              if (data.indexOf(search_data[key].toLowerCase()) === -1) {
                return false;
              }
            }

            // if object then loop
            if (typeof search_data[key] === 'object') {
              // loop through field values (checkboxes) [OR]
              var match = false;
              $.each(search_data[key], function(index, value) {
                if (data.indexOf(value.toLowerCase()) !== -1) {
                  match = true;
                }
              });
              if (!match) {
                return false;
              }
            }
          }
        }

        return true;
      },

      setFilters: function() {
        var self = this;
        if (jcms.searched) {
          self.$filters.form.submit();
          $('#slideoutSearch').trigger('input');
        }
        else if (localStorage.key('community-filters')) {
          var localStorageData = localStorage.getItem('community-filters');
          if (localStorageData && localStorageData.length > 2) {
            var savedData = JSON.parse(localStorageData);
            var i;
            for (i = 0; i <= self.$filters.all.length; i++) {
              var element = self.$filters.all[i];
              if (element && element.name) {
                var data = savedData[element.name];
                if (typeof data != 'undefined') {
                  if (typeof data === 'object' && (element.type == 'checkbox' || element.type == 'radio')) {
                    $.each(data, function(index, value) {
                      if (element.value == value) {
                        element.checked = true;
                      }
                    });
                  }
                  else {
                    element.value = data;
                    if (element.type == 'text') {
                      $(element).trigger('input');
                    }
                  }
                }
              }
            }
            self.$filters.form.submit();
            self.$filters.dummy.trigger('input');
          }
        }
      },

      showInputClear: function(element) {
        var self = this;

        if (typeof element != 'undefined' && element.length) {
          if (element.val().length) {
            element.parent().addClass('has-value');
          }
          else {
            element.parent().removeClass('has-value');
          }
        }
        else {
          $('[type="text"]', this.$filters.form).each(function() {
            self.showInputClear($(this));
          });
        }
      },

      filter: function() {
        var self = this;

        window.onpopstate = (event) => {
          this.$filters.submit.attr('data-popstate', 'true').trigger('click');
        };

        // DUMMY INPUT
        this.$filters.dummy.on('keyup touchend', function() {
          var id = $(this).data('filter-dummy');
          var value = this.value;
          var $input = self.$filters.input.filter('#' + id);
          $input.val(value).trigger('input');

          self.showInputClear($(this));
        });

        // INPUT/TEXT
        this.$filters.input.on('input keyup touchend', function() {
          var form = $(this).closest('form');
          var value = this.value;
          var id = $(this).attr('id');
          var $dummy = self.$filters.dummy.filter('[data-filter-dummy="' + id + '"]');
          $dummy.val(value).trigger('input');

          self.showInputClear($(this));
          self.showInputClear($dummy);

          // submit form
          form.submit();
        });

        // SELECT
        this.$filters.select.on('change', function() {
          var form = $(this).closest('form');
          form.submit();
        });

        // CHECKBOX
        this.$filters.checkbox.on('change', function() {
          var form = $(this).closest('form');
          form.submit();
        });

        // CHECKBOX
        this.$filters.reset.on('click', function() {
          var $form;
          if ($(this).attr('data-parent-form')) {
            $form = $($(this).data('parent-form'));
          }
          else {
            $form = $(this).closest('form');
          }
          $form.trigger('reset');

          $(':input', $form).each(function(index, element) {
            switch (element.type) {
              case 'text':
                $(this).val('').trigger('input');
                break;
              case 'checkbox':
              case 'radio':
                $(this).removeAttr('checked');
                break;
            }
          });

          $form.submit();
        });

        // CHECKBOX
        this.$filters.submit.on('click', function() {
          var form = $(this).closest('form');
          form.submit();
          $(this).closest('.slideout').find('[data-slideout="close"]').first().trigger('click');
        });

        // FORM SUBMIT
        this.$filters.form.on('submit', function(event) {
          event.preventDefault();
          self.matchedItems = [];
          var $form = $(this);
          let iFilterCount = 0;
          var oFormData = {};
          var formData = $(this).serializeArray();

          formData.forEach(function(data) {
            if (data.name.length > 0 && data.value) {
              iFilterCount++;
              if (data.name.match(/\[\]$/)) {
                var name = data.name.replace(/\[\]$/, '');
                if (!oFormData[name]) {
                  oFormData[name] = [];
                }
                oFormData[name].push(data.value);
              }
              else {
                oFormData[data.name] = data.value;
              }
            }
          });

          let aUrlParams = [];
          let sUrlParams = window.location.pathname + (jcms.devmode ? '?dev=1' : '');
          for (let key in oFormData) {
            // skip loop if the property is from prototype
            if (!oFormData.hasOwnProperty(key)) {
              continue;
            }
            aUrlParams.push(key + '=' + oFormData[key]);
          }

          if (aUrlParams.length) {
            sUrlParams += sUrlParams.includes('?') ? '&' : '?';
            sUrlParams += aUrlParams.join('&');
          }

          if (iFilterCount > 0) {
            self.$filters.filterCount.text(iFilterCount).show();
          }
          else {
            self.$filters.filterCount.hide().text('');
          }

          // Update URL
          window.history.pushState(false, false, sUrlParams);

          // loop through properties and start filtering
          self.$properties.each(function(propertyIndex, property) {
            var id = parseInt(property.dataset.property, 10);
            if (Object.keys(oFormData).length) {
              if (property.dataset.property && property.dataset.propertyData) {
                // check to make sure that there is form data
                var propertyData = JSON.parse(property.dataset.propertyData);
                if (self.validateProperty(oFormData, propertyData)) {
                  self.matchedItems.push(id);
                }
              }
            }
            else {
              self.matchedItems.push(id);
            }
          });

          // show/hide community cards
          self.$properties.hide();
          self.notMatchedItems = [];
          self.carouselMatchedClasses = [];

          if (self.matchedItems.length) {
            self.$noresults.parent().removeClass('no-results');
            self.$noresults.css('display', 'none');

            self.matchedItems.forEach(function(id) {
              $('[data-property="' + id + '"]').show();
              self.carouselMatchedClasses.push('.communities__card--' + id);
            });

            self.carouselMatchedClasses = self.carouselMatchedClasses.join(',');

            self.propertyIds.forEach(function(value) {
              if ($.inArray(value, self.matchedItems) == -1) {
                self.notMatchedItems.push(value);
              }
            });

            if (self.swiper && !self.swiper.destroyed) {
              var matchedSlides = [];
              self.$carouselCards.each(function(index, element) {
                if (self.matchedItems.length != self.propertyIds.length) {
                  if (self.matchedItems.indexOf($(this).data('property')) != -1) {
                    matchedSlides.push(element);
                  }
                }
                else {
                  matchedSlides.push(element);
                }
              });

              // first remove all then add filtered carousel slides
              if (self.swiper.initialized) {
                self.swiper.removeAllSlides();
                self.swiper.appendSlide(matchedSlides);
                self.swiper.update();
              }
              else {
                self.$carouselCards.remove();
                self.$cardsCarousel.children().append(matchedSlides);
                self.swiper.init();
              }
            }

            if (self.matchedItems.length === self.propertyIds.length) {
              self.$propertiesFilterInfoCount.text('');
              self.$propertiesFilterInfo.hide();
              self.$resultCount.text('View All ' + jcms.terminology.properties);
            }
            else {
              self.$propertiesFilterInfoCount.text(self.matchedItems.length + ' Result' + (self.matchedItems.length > 1 ? 's' : ''));
              self.$propertiesFilterInfo.show();
              self.$resultCount.text('View ' + self.matchedItems.length + ' ' + (self.matchedItems.length > 1 ? jcms.terminology.properties : jcms.terminology.property));
            }
          }
          else {
            self.$propertiesFilterInfoCount.text('');
            self.$propertiesFilterInfo.hide();
            self.$noresults.parent().addClass('no-results');
            self.$noresults.css('display', 'flex');
            self.$resultCount.text('No results found');
            // show all slider cards
            if (self.$cardsCarousel.hasClass('swiper-container-initialized')) {
              self.swiper.update();
            }
          }

          if (typeof (Storage) !== 'undefined') {
            localStorage.setItem('community-filters', localStorageData($form));
          }

          // show/hide map markers
          if (typeof map != 'undefined' && typeof corporateMap.markerVisibility == 'function') {
            corporateMap.markerVisibility(self.matchedItems, false, false);
          }
        });
      },

      cardActions: function() {
        var self = this;
        this.$properties
          .on('mouseover', function() {
            let id = $(this).data('property');
            if (typeof corporateMap != 'undefined') {
              corporateMap.focusMarker(id);
            }
          })
          .on('mouseout', function() {
            let id = $(this).data('property');
            if (typeof corporateMap != 'undefined') {
              corporateMap.unfocusMarker(id);
            }
          });

        // make an array of all property ids
        this.$properties.each(function() {
          self.propertyIds.push($(this).data('property'));
        });

        self.$cardLinks.click(function() {
          var property_id = $(this).parent().attr('data-property-id');
          sessionStorage.setItem('property-clicked', property_id);
        });
      },

      buttons: function() {
        var self = this;

        function preventMotion(event) {
          event.preventDefault();
          event.stopPropagation();
        }

        this.$mapToggle.click(function(event) {
          event.preventDefault();
          self.$mapContainer.fadeToggle(function() {
            if ($(this).is(':visible')) {

              $('html, body').css('overflow', 'hidden');
              $('body').css('position', 'relative');
              window.addEventListener('scroll', preventMotion, false);
              window.addEventListener('touchmove', preventMotion, false);

              self.$cardsCarousel.find('.lazyload').each(function() {
                if ($(this).attr('data-src')) {
                  $(this).css('background-image', 'url(' + $(this).data('src') + ')').removeAttr('data-src');
                }
              });

              if (!self.swiper || !self.swiper.initialized || self.swiper.destroyed) {
                self.swiper.init();
              }
              else {
                self.swiper.update();
              }
              self.carouselActions();
            }
            else {
              $('html, body').css('overflow', '');
              $('body').css('position', '');
              window.removeEventListener('scroll', preventMotion, false);
              window.removeEventListener('touchmove', preventMotion, false);
            }
          });
        });
      },

      carousel: function() {
        var self = this;

        if (window.innerWidth <= jcms.breakpoints.fluid) {
          self.swiper = new Swiper('.communities__card-items', {
            slidesPerView: 'auto',
            slidesOffsetBefore: 30,
            slidesOffsetAfter: 30,
            init: false,
            allowTouchMove: true,
            mousewheel: {
              forceToAxis: true,
              sensitivity: 1,
              invert: true
            }
          });

          this.carouselActions();
        }
      },

      carouselActions: function() {
        var self = this;
        if (self.swiper) {
          self.swiper.on('afterInit slideChange update', function() {
            if (!self.swiper.destroyed && self.swiper.slides.length) {
              var index = self.swiper.activeIndex;
              var id = self.swiper.slides[index].dataset.property;
              corporateMap.focusMarker(id);
            }
          });
        }
      },

      cardHover: function() {
        var _ = this;
        if (_.$propertyCards.length) {
          _.$propertyCards.mouseenter(function() {
            _.$propertyCards.removeClass('hover');
            $(this).addClass('hover');
          }).mouseleave(function() {
            $(this).removeClass('hover');
          });
        }
      },

      mapCardClicks: function() {
        $(document).on('click', '.communities__card-link', function() {
          var property_id = $(this).parent().attr('data-property-id');
          sessionStorage.setItem('property-clicked', property_id);
        });

        $(document).on('click', 'a:not(.communities__card-link):not(.communities__item-link)', function() {
          sessionStorage.removeItem('property-clicked');
        });
      },

      pageScroll: function() {
        var _ = this;

        if (_.$propertiesMain.length) {
          var id = sessionStorage.getItem('property-clicked');

          if (typeof id != 'undefined') {
            var offset;
            var $card = $('.communities__item[data-property-id="' + id + '"]');
            if (typeof $card != 'undefined' && $card.length) {
              $card.addClass('hover');

              if ($(window).width() <= jcms.breakpoints.fluid) {
                offset = $card.offset().top - _.$header.height() - 40;
                $('html, body').animate({
                  scrollTop: offset
                });
              }
              else {
                offset = $card.offset().top - (_.$propertiesMain.scrollTop() + _.$propertiesMain.offset().top);
                _.$propertiesMain.animate({
                  scrollTop: offset
                });
              }
            }
          }
        }
      },

      ready: function() {
        this.dom();
        this.definitions();
        this.filter();
        this.cardActions();
        this.buttons();
        this.cardHover();

        setTimeout(function() {
          communities.pageScroll();
        }, 1000);

        // if map is being used we need to hold off on pre-populating form data
        // otherwise it will cause a JS error
        if (jcms.communitiesMap) {
          var loopNum = 0;
          var mapLoaded = setInterval(function() {
            loopNum++;
            if (typeof corporateMap != 'undefined' && typeof corporateMap.properties === 'object' && typeof google === 'object' && typeof google.maps === 'object') {
              clearInterval(mapLoaded);
              setTimeout(function() {
                communities.mapHasLoaded = true;
                communities.setFilters();
                communities.mapCardClicks();
              }, 500);
            }
            else if (loopNum >= 10) {
              clearInterval(mapLoaded);
              return false;
            }
          }, 500);
        }
        else {
          this.setFilters();
        }
      }
    };

    $(function() { communities.ready(); });

    $(window).on('load resize', function() {
      if (typeof communities.$header == 'undefined') {
        communities.dom();
      }
      communities.setHeights(event);
      if (jcms.communitiesMap) {
        communities.carousel();
      }
    });
  }

})(jQuery);
